import BaseModel from '@/models/BaseModel.js'

export default class School extends BaseModel {
    fields =  {
        'school_name': {
          label: 'Nama Sekolah',
          type: 'text',
          rules: 'required'
        },
        'kepsek': {
          label: 'Kepala Sekolah',
          type: 'text',
          rules: 'required'
        },
        'npsn': {
          label: 'NPSN',
          type: 'text',
          rules: 'required'
        },
        'bendahara': {
          label: 'Bendahara',
          type: 'text',
          rules: 'required'
        },
        'total_student': {
          label: 'Jumlah Siswa',
          type: 'number',
          rules: 'required'
        },
      // 'address': {
      //   label: 'Alamat',
      //   type: 'text',
      //   rules: 'required'
      // },
        'district_id' : {
          type: 'enum',
          label: 'Kecamatan',
          rules: 'required',
          options: []
        },
        'village_id' : {
          type: 'enum',
          label: 'Kelurahan/Desa',
          rules: 'required',
          options: []
        },
        'name': {
          label: 'Nama Akun',
          type: 'text',
          rules: 'required'
        },
        'username': {
          label: 'Nama Pengguna',
          type: 'text',
          rules: 'required'
        },
        'password': {
          label: 'Kata Sandi',
          type: 'password',
          rules: 'required'
        },
        'email': {
          label: 'Email',
          type: 'email',
          rules: 'required'
        },
        'phone_number': {
          label: 'Kontak',
          type: 'text',
          rules: 'required'
        },
      }
    
    endpoint = process.env.VUE_APP_API_URL + 'schools'
}